
import ModelData from "../../../public/model_data";
import EventManager from "../../../../manager/event_manager";
import NotifyServer from "../../server/notify/notify_server";
import { Notify } from "../../server/notify/proto_notify";
import LoaclStorage from "../../../../manager/local_storage";



class ChatData {

    worldChatData: Notify.GroupChatMessage.IGroupChatContent[] = []
    systemChatData: string[] = []

    clubChatData: Notify.GroupChatMessage.IGroupChatContent[] = []
    

    recentChatData : { type : number,name : string, content : string };

    constructor() {

        EventManager.instance.on("Event_Notify_Connected", this.on_notify_connected,this,true);
        EventManager.instance.on("Event_Notify_Group_Chat_Data", this.on_group_chat, this, true);
        
    }

    private on_notify_connected(isReconnected : boolean){

        let messageData: Notify.IActionGroupChatMessage = {
            groupChatName: "world",
            action: 1,
        }

        this.worldChatData = [];
        NotifyServer.instance.sendActionGroupChatMessage(messageData)
    }

    private on_group_chat(chatMsg: Notify.GroupChatMessage) {

        if (chatMsg.contentList.length == 0) {
            return;
        }
        
        let resetData = this.worldChatData.length == 0 ;
      
        for (let i = 0; i < chatMsg.contentList.length; i++) {
            this.worldChatData.push(chatMsg.contentList[i])
        }

        //裁剪只显示最近60条数据
        let maxCount = 20;
        if (this.worldChatData.length > maxCount) {
            this.worldChatData.splice(0, this.worldChatData.length - maxCount)
        }

        if (chatMsg.contentList.length > 0) {
         
            let data = chatMsg.contentList[chatMsg.contentList.length-1];
            this.recentChatData = {type : 1,name : data.nickName,content: data.content};
  
            EventManager.instance.dispatch("Event_Notify_Recent_Chat",this.recentChatData);
        }

        //这里处理聊天显示
        EventManager.instance.dispatch("Event_Notify_World_Chat",resetData,resetData ? this.worldChatData : chatMsg.contentList);

    }
   
    saveFriendData(chatMsg: Notify.ChatMessage) {
        let keyName = ModelData.instance.roleData.id.toString() + "_FriendChatMsg"
        let keyItem = localStorage.getItem(keyName);

        let msgList: Notify.ChatMessage[] = keyItem ? JSON.parse(keyItem) : []
     
        let avatarId = ModelData.instance.roleData.id;

        let senderId = Number(chatMsg.sendUserId);
        let receiverId = Number(chatMsg.recverUserId);

        let friendId = avatarId == senderId ? receiverId : senderId ;
        
        //取最近50条
        msgList.push(chatMsg)

        let maxCount = 50
        if (msgList.length > maxCount) {
            msgList.splice(0,msgList.length - maxCount);
        }

        let stringify = JSON.stringify(msgList);
        localStorage.setItem(keyName, stringify);
        
        this.recentChatData = {type : 2,name : JSON.parse(chatMsg.content).nickName,content : JSON.parse(chatMsg.content).content }
        EventManager.instance.dispatch("Event_Notify_Recent_Chat",this.recentChatData);

    }

    saveChatFriend(list : any[]){

        let keyName = ModelData.instance.roleData.id.toString() + "_ChatFriendList"

        localStorage.setItem(keyName,JSON.stringify(list));
    }

    getChatFriend(){

        let keyName = ModelData.instance.roleData.id.toString() + "_ChatFriendList"

        let item = localStorage.getItem(keyName) ;
        return item ? JSON.parse(item) : [];
    }


    getFriendData() : Notify.ChatMessage[] {
        let keyName = ModelData.instance.roleData.id.toString() + "_FriendChatMsg"
        let keyItem = localStorage.getItem(keyName);
        let msgList: Notify.ChatMessage[] = keyItem ? JSON.parse(keyItem, (key, value) => {

            if (key == "sendUserId" || key == "recverUserId") {
                return Number(value);
            } else {
                return value;
            }
        }) : [];


        return msgList
    }

    clearFriendData(friendId : number){

        let msgList = this.getFriendData();

        msgList = msgList.filter((value)=>{
            return (value.recverUserId != friendId && value.sendUserId != friendId);                            
        })

        let keyName = ModelData.instance.roleData.id.toString() + "_FriendChatMsg"
        localStorage.removeItem(keyName);

        let stringify = JSON.stringify(msgList);
        localStorage.setItem(keyName,stringify);

        return msgList;
    }

    reset() {
        this.recentChatData = null
    }
   
}

export let chat_data = new ChatData();